// extracted by mini-css-extract-plugin
export default {"error":"_22eBf3pZImsiSdKzRL9BQM"};